(function () {
  'use strict';

  /* @ngdoc object
   * @name main.edit
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.edit', [
      'ui.router'
    ]);
}());
